import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { Form } from "react-final-form";
import * as yup from "yup";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import FormControlLabel from "@mui/material/FormControlLabel";
import { UiInputGroupWr } from "../../../../../../_uiComponents/common/form/UiInputComponents";
import UiInput from "../../../../../../_uiComponents/UiInput";
import UiSwitch from "../../../../../../_uiComponents/common/form/UiSwitch";
import UiCropFileUpload from "../../../../../../_uiComponents/common/form/UiCropFileUpload";
import {
     UiButton,
     UiBackButton,
     UiIconButton,
} from "../../../../../../_uiComponents/common/form/UiButton";
import { UiEditor } from "../../../../../../_uiComponents/common/form/UiStyledInputs";
import Validator from "../../../../../../../_helpers/validate.schema";
import PublishedTable from "../PublishedTable";

import {
     incentiveAboutPublishedRevisionRequest,
     incentiveAddAboutCampaignRequest,
} from "../../../../../../../_redux/_actions";

const validateSchema = () =>
     yup.object().shape({
          menuTitle: yup.string().max(50, "tile characters are more than 50"),

          sectionOneTitle: yup
               .string()
               .max(50, "tile characters are more than 50"),
          sectionTwoTitle: yup
               .string()
               .max(50, "tile characters are more than 50"),
          sectionThreeTitle: yup
               .string()
               .max(50, "tile characters are more than 50"),
          sectionFourTitle: yup
               .string()
               .max(50, "tile characters are more than 50"),

          sectionOneDesc: yup
               .string()
               .max(2500, "tile characters are more than 2500"),
          sectionTwoDesc: yup
               .string()
               .max(2500, "tile characters are more than 2500"),
          sectionThreeDesc: yup
               .string()
               .max(2500, "tile characters are more than 2500"),
          sectionFourDesc: yup
               .string()
               .max(2500, "tile characters are more than 2500"),

          changeReason: yup
               .string()
               .max(50, "tile characters are more than 50"),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function AboutTheCampaignForm(props) {
     const actionDispatch = useDispatch();
     const { id } = useParams();

     const [initialValuesList, setInitialValuesList] = useState({});

     useEffect(() => {
          actionDispatch(
               incentiveAboutPublishedRevisionRequest({
                    campaignId: props.campaignId,
               }),
          );
     }, []);

     const { contentAboutDetails, publishedData, imageUpload } = useSelector(
          (state) => {
               return {
                    publishedData:
                         state.incentive.contentAboutRevisionPublished,
                    contentAboutDetails: state.incentive.contentAboutDetails,
                    imageUpload: state.incentive,
               };
          },
     );

     useEffect(() => {
          let tempObj = {};

          if (contentAboutDetails?.MenuTitle) {
               tempObj.menuTitle = contentAboutDetails.MenuTitle;

               if (
                    contentAboutDetails
                         ?.IncentiveCampaignContentAboutCampaignSectionDtos?.[0]
               ) {
                    let sectionOneObj =
                         contentAboutDetails
                              ?.IncentiveCampaignContentAboutCampaignSectionDtos?.[0];

                    tempObj.sectionOneTitle = sectionOneObj.title;
                    tempObj.sectionOneImg = imageUpload?.imageOne?.data?.fileId;
                    tempObj.sectionOneImgUrl = sectionOneObj.bannerImageUrl;
                    tempObj.sectionOneDesc =
                         sectionOneObj.descriptionHtmlContent;
               }

               if (
                    contentAboutDetails
                         ?.IncentiveCampaignContentAboutCampaignSectionDtos?.[1]
               ) {
                    let sectionTwoObj =
                         contentAboutDetails
                              ?.IncentiveCampaignContentAboutCampaignSectionDtos?.[1];

                    tempObj.sectionTwoTitle = sectionTwoObj.title;
                    tempObj.sectionTwoImg = imageUpload?.imageTwo?.data?.fileId;
                    tempObj.sectionTwoImgUrl = sectionTwoObj.bannerImageUrl;
                    tempObj.sectionTwoDesc =
                         sectionTwoObj.descriptionHtmlContent;
               }

               if (
                    contentAboutDetails
                         ?.IncentiveCampaignContentAboutCampaignSectionDtos?.[2]
               ) {
                    let sectionThreeObj =
                         contentAboutDetails
                              ?.IncentiveCampaignContentAboutCampaignSectionDtos?.[2];

                    tempObj.sectionThreeTitle = sectionThreeObj.title;
                    tempObj.sectionThreeImg =
                         imageUpload?.imageThree?.data?.fileId;
                    tempObj.sectionThreeImgUrl = sectionThreeObj.bannerImageUrl;
                    tempObj.sectionThreeDesc =
                         sectionThreeObj.descriptionHtmlContent;
               }

               if (
                    contentAboutDetails
                         ?.IncentiveCampaignContentAboutCampaignSectionDtos?.[3]
               ) {
                    let sectionFourObj =
                         contentAboutDetails
                              ?.IncentiveCampaignContentAboutCampaignSectionDtos?.[3];

                    tempObj.sectionFourTitle = sectionFourObj.title;
                    tempObj.sectionFourImg =
                         imageUpload?.imageFour?.data?.fileId;
                    tempObj.sectionFourImgUrl = sectionFourObj.bannerImageUrl;
                    tempObj.sectionFourDesc =
                         sectionFourObj.descriptionHtmlContent;
               }

               setInitialValuesList(tempObj);
          }
     }, [contentAboutDetails]);

     const submitData = async (values, form) => {
          let finalPayload = {
               id: id,
               menuTitle: values.menuTitle,
               incentiveCampaignContentAboutCampaignSectionDtos: [],
               changeReason: values.changeReason ? values.changeReason : "",
               page: 1,
               pageSize: 5,
               form,
          };

          if (values?.sectionOneTitle) {
               let payload = {
                    section: 1,
                    title: values.sectionOneTitle,
                    descriptionHtmlContent: values.sectionOneDesc,
                    bannerFileId: imageUpload?.imageOne?.data?.fileId,
               };

               finalPayload.incentiveCampaignContentAboutCampaignSectionDtos.push(
                    payload,
               );
          }

          if (values?.sectionTwoTitle) {
               let payload = {
                    section: 2,
                    title: values.sectionTwoTitle,
                    descriptionHtmlContent: values.sectionTwoDesc,
                    bannerFileId: imageUpload?.imageTwo?.data?.fileId,
               };

               finalPayload.incentiveCampaignContentAboutCampaignSectionDtos.push(
                    payload,
               );
          }

          if (values?.sectionThreeTitle) {
               let payload = {
                    section: 3,
                    title: values.sectionThreeTitle,
                    descriptionHtmlContent: values.sectionThreeDesc,
                    bannerFileId: imageUpload?.imageThree?.data?.fileId,
               };

               finalPayload.incentiveCampaignContentAboutCampaignSectionDtos.push(
                    payload,
               );
          }

          if (values?.sectionFourTitle) {
               let payload = {
                    section: 4,
                    title: values.sectionFourTitle,
                    descriptionHtmlContent: values.sectionFourDesc,
                    bannerFileId: imageUpload?.imageFour?.data?.fileId,
               };

               finalPayload.incentiveCampaignContentAboutCampaignSectionDtos.push(
                    payload,
               );
          }

          actionDispatch(incentiveAddAboutCampaignRequest(finalPayload));

          setInitialValuesList({});
     };

     const [value, setValue] = useState(1);

     const handleChange = (event) => {
          setValue(event.target.value);
     };
   
     return (
          <>
               <Form
                    initialValues={initialValuesList}
                    onSubmit={submitData}
                    validate={onValidate}
                    mutators={{
                         setFormAttribute: (
                              [fieldName, fieldVal],
                              state,
                              { changeValue },
                         ) => {
                              changeValue(state, fieldName, () => fieldVal);
                         },
                    }}
                    render={({ form, handleSubmit, values }) => {
                         return (
                              <form onSubmit={validateSchema}>
                                   <div className="sbm-content-section">
                                        <Grid
                                             container
                                             spacing={2}
                                             sx={{ mt: 1 }}
                                        >
                                            
                                             <Grid item xs={12} lg={6}>
                                                  <UiInput
                                                       type="text"
                                                       label="Menu Title"
                                                       name="menuTitle"
                                                  />
                                             </Grid>
                                             <Grid item xs={12} lg={12}>
                                             <RadioGroup row value={value} onChange={handleChange}>
                                                  <FormControlLabel value="1" control={<Radio />} label="One Image" />
                                                  <FormControlLabel value="2" control={<Radio />} label="Two Images " />
                                                  <FormControlLabel value="4" control={<Radio />} label="Four Images" />
                                             </RadioGroup>
                                             </Grid>

                                             <Grid item xs={12} lg={12}>
                                                  <Grid container spacing={2}>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={12}
                                                       >
                                                            <Grid
                                                                 container
                                                                 spacing={2}
                                                            >
                                                                 {(value == 1 || value == 2 || value == 4)  && (
                                                                 <Grid
                                                                      item
                                                                      xs={12}
                                                                      lg={6}
                                                                 >
                                                                      <UiCropFileUpload
                                                                           defaultImage={
                                                                                values.sectionOneImgUrl
                                                                           }
                                                                           setToDefault={
                                                                                !contentAboutDetails
                                                                           }
                                                                           aspectRatio={
                                                                                3 /
                                                                                2
                                                                           }
                                                                           type={
                                                                                "imageOne"
                                                                           }
                                                                           minWidth="320"
                                                                           label="Image 01"
                                                                           uploadSize="Min. image size 320px x 240px"
                                                                           setUploadValue={(
                                                                                value,
                                                                           ) => {
                                                                                form.mutators.setFormAttribute(
                                                                                     "sectionOneImg",
                                                                                     value,
                                                                                );
                                                                           }}
                                                                      />
                                                                 </Grid>)}
                                                                 {(value == 2 || value == 4)  && (
                                                                 <Grid
                                                                      item
                                                                      xs={12}
                                                                      lg={6}
                                                                 >
                                                                      <UiCropFileUpload
                                                                           defaultImage={
                                                                                values.sectionTwoImgUrl
                                                                           }
                                                                           setToDefault={
                                                                                !contentAboutDetails
                                                                           }
                                                                           aspectRatio={
                                                                                3 /
                                                                                2
                                                                           }
                                                                           type={
                                                                                "imageTwo"
                                                                           }
                                                                           minWidth="320"
                                                                           label="Image 02"
                                                                           uploadSize="Min. image size 320px x 240px"
                                                                           setUploadValue={(
                                                                                value,
                                                                           ) => {
                                                                                form.mutators.setFormAttribute(
                                                                                     "sectionTwoImg",
                                                                                     value,
                                                                                );
                                                                           }}
                                                                      />
                                                                 </Grid>)}
                                                                 {value == 4  && (
                                                                 <Grid
                                                                      item
                                                                      xs={12}
                                                                      lg={6}
                                                                 >
                                                                      <UiCropFileUpload
                                                                           defaultImage={
                                                                                values.sectionThreeImgUrl
                                                                           }
                                                                           setToDefault={
                                                                                !contentAboutDetails
                                                                           }
                                                                           aspectRatio={
                                                                                3 /
                                                                                2
                                                                           }
                                                                           type={
                                                                                "imageThree"
                                                                           }
                                                                           minWidth="320"
                                                                           label="Image 03"
                                                                           uploadSize="Min. image size 320px x 240px"
                                                                           setUploadValue={(
                                                                                value,
                                                                           ) => {
                                                                                form.mutators.setFormAttribute(
                                                                                     "sectionThreeImg",
                                                                                     value,
                                                                                );
                                                                           }}
                                                                      />
                                                                 </Grid>)}
                                                                 {value == 4  && (
                                                                 <Grid
                                                                      item
                                                                      xs={12}
                                                                      lg={6}
                                                                 >
                                                                      <UiCropFileUpload
                                                                           defaultImage={
                                                                                values.sectionFourImgUrl
                                                                           }
                                                                           setToDefault={
                                                                                !contentAboutDetails
                                                                           }
                                                                           aspectRatio={
                                                                                3 /
                                                                                2
                                                                           }
                                                                           type={
                                                                                "imageFour"
                                                                           }
                                                                           minWidth="320"
                                                                           label="Image 04"
                                                                           uploadSize="Min. image size 320px x 240px"
                                                                           setUploadValue={(
                                                                                value,
                                                                           ) => {
                                                                                form.mutators.setFormAttribute(
                                                                                     "sectionFourImg",
                                                                                     value,
                                                                                );
                                                                           }}
                                                                      />
                                                                 </Grid>)}
                                                                 <Grid
                                                                      item
                                                                      xs={12}
                                                                      lg={12}
                                                                 >
                                                                      <UiEditor
                                                                           value={
                                                                                values.sectionOneDesc
                                                                           }
                                                                           setDescValue={(
                                                                                value,
                                                                           ) => {
                                                                                form.mutators.setFormAttribute(
                                                                                     "sectionOneDesc",
                                                                                     value,
                                                                                );
                                                                           }}
                                                                           title="Description"
                                                                      />
                                                                 </Grid>
                                                            </Grid>
                                                       </Grid>

                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={6}
                                                            className="sba-campaign-content-text-bg"
                                                       >
                                                            <UiInput
                                                                 type="text"
                                                                 name="changeReason"
                                                                 multiline={
                                                                      true
                                                                 }
                                                                 minRows={3}
                                                                 maxRows={5}
                                                                 label="Change Reason"
                                                            />
                                                       </Grid>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={12}
                                                            sx={{ mb: 2 }}
                                                       >
                                                            <Stack
                                                                 spacing={2}
                                                                 direction="row"
                                                                 justifyContent="end"
                                                                 sx={{
                                                                      width: "100%",
                                                                 }}
                                                            >
                                                                 <UiButton
                                                                      name="Clear"
                                                                      variant="outlined"
                                                                      size="small"
                                                                      onClick={() => {
                                                                           form.reset();
                                                                           setInitialValuesList(
                                                                                {},
                                                                           );
                                                                      }}
                                                                 />
                                                                 <UiButton
                                                                      name="Save"
                                                                      variant="contained"
                                                                      size="small"
                                                                      onClick={
                                                                           handleSubmit
                                                                      }
                                                                 />
                                                            </Stack>
                                                       </Grid>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={12}
                                                       >
                                                            <div className="sba-revison-publish-table">
                                                                 <label class="sba-content-label">
                                                                      Published
                                                                      Revision
                                                                      Content
                                                                 </label>
                                                                 <PublishedTable
                                                                      loadData={
                                                                           props.loadAboutRevisionData
                                                                      }
                                                                      publishedData={
                                                                           publishedData
                                                                      }
                                                                 />
                                                            </div>
                                                       </Grid>
                                                  </Grid>
                                             </Grid>
                                        </Grid>
                                   </div>
                              </form>
                         );
                    }}
               />
          </>
     );
}
